import React from 'react';
import { StarIcon } from '../common/Icons';

const SalonCard = ({ salon, onClick }) => {
  const { name, rating, reviews, address, image, distance } = salon;
  
  return (
    <div className="flex bg-white rounded-lg shadow p-3" onClick={onClick}>
      <img src={image} alt={name} className="w-20 h-20 rounded-lg object-cover mr-3" />
      <div className="flex-1">
        <div className="flex items-center">
          <h3 className="font-bold text-lg">{name}</h3>
        </div>
        <div className="flex items-center my-1">
          <StarIcon size={16} fill="#FFD700" stroke="#FFD700" className="mr-1" />
          <span className="font-bold">{rating}</span>
          <span className="text-gray-500 text-sm ml-1">({reviews} evaluări)</span>
        </div>
        <p className="text-gray-600 text-sm">{distance} - {address}</p>
      </div>
    </div>
  );
};

export default SalonCard;